import React from 'react';
export function Footer() {
  return <footer className="py-10 mt-12 border-t border-white/10 text-center" data-id="element-51">
      <div className="mb-6" data-id="element-52">
        <h3 className="text-2xl font-extrabold text-white tracking-tight" data-id="element-53">
          LumiMate<span className="text-brand-orange" data-id="element-54">.</span>
        </h3>
      </div>

      <div className="flex justify-center gap-6 mb-8 text-brand-muted text-sm" data-id="element-55">
        <a href="#" className="hover:text-brand-orange transition-colors" data-id="element-56">
          Privacy Policy
        </a>
        <a href="#" className="hover:text-brand-orange transition-colors" data-id="element-57">
          Terms of Service
        </a>
        <a href="#" className="hover:text-brand-orange transition-colors" data-id="element-58">
          Contact Us
        </a>
      </div>

      <p className="text-brand-muted/50 text-xs" data-id="element-59">
        &copy; {new Date().getFullYear()} LumiMate. All rights reserved.
      </p>
    </footer>;
}